module.exports = __webpack_public_path__ + "img/webinarjam.74dae10f.svg";